import { graphql, useStaticQuery } from 'gatsby'

import { Footer } from '@application/Types/FooterTypes'
import type { Opt } from '@application/Types/Opt'

const useGetFooter = (language = 'en'): Opt<Footer> => {
    const data = useStaticQuery(
        graphql`
            query {
                allStrapiFooter {
                    nodes {
                        aboutUsHeader
                        copyrightText
                        showLogoCarousel
                        description {
                            data {
                                description
                                childMarkdownRemark {
                                    html
                                }
                            }
                        }
                        facebookLink
                        getInTouchHeader
                        linkedInLink
                        language
                        twitterLink
                        updatedAt
                        resourcesHeader
                        aboutUsLinks {
                            label
                            link
                        }
                        getInTouchItems {
                            countryName
                            phoneNumber
                        }
                        resourcesLinks {
                            label
                            link
                        }
                        seoLinksSection {
                            title
                            seoLinks {
                                link
                                label
                                title
                            }
                        }
                    }
                }
            }
        `
    )

    /*
     * used resourcesHeader field as do-not-remove
     */
    return data?.allStrapiFooter.nodes.find(
        (node: Footer) => node.language === language && !node.resourcesHeader.includes('do-not-remove')
    )
}

export { useGetFooter }
